<template>
    <b-modal ref="mdlConfigurazioneUosd" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="l">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonData.descrizione" required> </b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSaveConfigurazioneUosd()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        ModalError,
    },
    data() {
        return {
            pathResource: "/malattieinfettiveuosd",
            perPage: 10000000,
            title: "Configurazione Uosd",
            currentPage: 1,
            listKey: 0,
            jsonData: {
                id: null,
                descrizione: null,
            },
        };
    },
    mounted() {},
    methods: {
        setId(id) {
            let me = this;
            me.id = id;
            if (id === null) {
                me.jsonData = { id: null, descrizione: null };
            } else {
                me.loadData();
            }

            me.$refs.mdlConfigurazioneUosd.show();
        },
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            console.log("Errore nel caricamento dei parametri vitali", error);
        },
        onCloseModal() {
            let me = this;
            me.jsonData = { id: null, descrizione: null };
            me.$refs.mdlConfigurazioneUosd.hide();
            me.$emit("onCloseModal");
        },
        onClickSaveConfigurazioneUosd() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.saveConfigurazioneUosdSuccess, me.saveConfigurazioneUosdError);
        },
        saveConfigurazioneUosdSuccess(response) {
            let me = this;
            me.$emit("onSaveUosd", response);
            me.$refs.mdlConfigurazioneUosd.hide();
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        saveConfigurazioneUosdError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteUosd(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questo parametro vitale?", {
                    title: "Eliminazione Parametro Vitale",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteUosd(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteUosd(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, me.jsonData, me.onDeleteUosdSuccess, me.onDeleteUosdError);
        },
        onDeleteUosdSuccess(response) {
            let me = this;
            me.$emit("deleteUosd", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        onDeleteUosdError(response) {
            let me = this;
            me.$emit("deleteUosd", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
